import { IErrorState } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IErrorState = {
  error403: false,
  error404: false,
  error500: false,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError403: (state, action: PayloadAction<boolean>) => {
      state.error403 = action.payload;
    },
    setError404: (state, action: PayloadAction<boolean>) => {
      state.error404 = action.payload;
    },
    setError500: (state, action: PayloadAction<boolean>) => {
      state.error500 = action.payload;
    },
  },
});

const { actions, reducer }: any = errorSlice;
export { actions as errorActions, reducer as errorReducer };
